import axios from "axios";
import { APIPaths } from "../common/constants";
import interceptor from "../common/interceptor";

export const GetAirportsAndAirlineData = (airport, airline) => {
    return axios
        .get(
            `https://aeroapi.flightaware.com/aeroapi/airports/${airport}/flights?airline=${airline}`,
            {
                headers: {
                    Accept: "application/json; charset=UTF-8",
                    "x-apikey": "YJyRh8juUQirGdFfCBUA9muAlq71df2X"
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            console.log("Error Response:", error.response);
            throw error.response;
        });
};

export const GetAirportsFlightData = (airport) => {
    return axios
        .get(
            `https://aeroapi.flightaware.com/aeroapi/airports/${airport}/flights`,
            {
                headers: {
                    Accept: "application/json; charset=UTF-8",
                    "x-apikey": "YJyRh8juUQirGdFfCBUA9muAlq71df2X"
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            console.log("Error Response:", error.response);
            throw error.response;
        });
};

export const GetAirportDelaysFlightData = (airport) => {
    return axios
        .get(
            `https://aeroapi.flightaware.com/aeroapi/airports/${airport}/delays`,
            {
                headers: {
                    Accept: "application/json; charset=UTF-8",
                    "x-apikey": "YJyRh8juUQirGdFfCBUA9muAlq71df2X"
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            console.log("Error Response:", error.response);
            throw error.response;
        });
};

//get airport contacts 
export const GetAirportsContacts = (query, token) => {
    const url = `${APIPaths.airport_contacts}${query}`;
    return new Promise((resolve, reject) => {
      interceptor
        .axiosGet("Get", url, token, null)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log("error?.response?.data?.error", error?.response);
          reject(error?.response);
        });
    });
  };

  export const AddAirportContact = (model, token ) => {
    return new Promise((resolve, reject) => {
      interceptor
        .axiosPost("Post", APIPaths.airport_contacts, model, token)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log("error?.response?.data?.error", error?.response);
          reject(error?.response);
        });
    });
  };
//get airport contacts 
// export const AddAirportContact = (id, token) => {
//     // const url = `${APIPaths.airport_contacts}${id}/`;
//     const url = `${APIPaths.airport_contacts}`;
//     return new Promise((resolve, reject) => {
//       interceptor
//         .axiosGet("Get", url, token, null)
//         .then((res) => {
//           resolve(res);
//         })
//         .catch((error) => {
//           console.log("error?.response?.data?.error", error?.response);
//           reject(error?.response);
//         });
//     });
//   };
//get airport contacts 
  export const DeleteAirportContact = (id, token) => {
    const url = `${APIPaths.airport_contacts}${id}/`;
    return new Promise((resolve, reject) => {
      interceptor
        .axiosDelete("Delete", url, null, token)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log("error?.response?.data?.error", error?.response);
          reject(error?.response);
        });
    });
  };

  //get airport data [mahtab] 
export const GetAirportsData = (query, token) => {
  // LAX/airlines/?type=2
  const url = `${APIPaths.airport_data}${query}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response getting airport data", error?.response);
        reject(error?.response);
      });
  });
};

export const getCustomsOfficesByIata = async (iataCode, token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", `${APIPaths.customs_offices}${iataCode}/`, token, null)
      .then((res) => {
        resolve(res.data.data);
      })
      .catch((error) => {
        console.log("error?.response getting customs office", error?.response);
        reject(error?.response);
      });
  });
};
